module.exports = __webpack_public_path__ + "img/ls_img1.cc9b4896.png";